module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-200.95f4da77.woff";